import { useCustomMutation } from '../../graphql';

export const useChangeWorkspace = () => {
  return useCustomMutation({
    query: CHANGE_WORKSPACE,
  });
};

const CHANGE_WORKSPACE = `
  mutation ChangeWorkspace($input: ChangeWorkspaceInput!) {
    account {
      changeWorkspace(input: $input) {
        success,
        message
      }
    }
  }
`;
